import { object, number, array, boolean, date } from 'yup'

import { FormikWizardStepType } from '../../../node_modules/formik-wizard/dist/types.d'
import { Quoting } from './Steps/Quoting'
import { Recurrence } from './Steps/Recurrence'
import { Finance } from './Steps/Finance'
import { Legal } from './Steps/Legal'
import { getTotalValue } from '../../shared/helpers/offer'
import { OfferInput } from '../../shared/types/skus'

const steps: FormikWizardStepType[] = [
  {
    id: 'plan',
    component: Quoting,
    actionLabel: 'Quoting',
    initialValues: {
      input: {
        offerSkuId: '',
        bundleId: '',
        dealValue: '',
        quantity: 1,
        duration: 1,
        index: 1,
        isRenewable: false,
        isRecurring: false,
        startDate: new Date()
      },
      offers: []
    },
    validationSchema: object().shape({
      offers: array().of(
        object().shape({
          offerSkuId: number(),
          bundleId: number(),
          dealValue: number().required(),
          quantity: number().required().default(1),
          duration: number().required().default(1),
          index: number().required().default(1)
        })
      )
    }),
    onAction: async (sectionValues: any, formValues: any) => {
      const validOffers = sectionValues.offers.filter(
        (offer: OfferInput) => !offer.isChurn
      )

      if (validOffers.length === 0) {
        throw new Error('Please, enter one or more offers to go ahead!')
      }
    },
  },
  {
    id: 'plan2',
    component: Recurrence,
    actionLabel: 'Recurrence'
  },
  {
    id: 'finance',
    component: Finance,
    actionLabel: 'Finance',
    validate: (values: any[]) => {
      const validation = values.reduce((errors, offer: any, index: number) => {
        const messages: string[] = []
        const totalValue = getTotalValue(offer)

        if (offer.isChurn) {
          return errors
        }
        
        if(!offer.payment?.installmentPaymentMethodId
          && ((offer.payment?.upfrontValue || 0) < totalValue)
          ) {
          messages.push('Payment method is required')
        }
        if(!offer.payment?.firstInstallmentDate
            && ((offer.payment?.upfrontValue || 0) < totalValue)
        ) {
          messages.push('First installment date is required')
        }

        if (offer.payment?.hasUpfront && !offer.payment?.upfrontValue) {
          messages.push('Upfront value is required')
        }

        if (offer.payment?.hasUpfront && !offer.payment?.upfrontDate) {
          messages.push('Upfront payment date is required')
        }

        if (offer.payment?.hasUpfront && !offer.payment?.upfrontPaymentMethodId) {
          messages.push('Upfront payment method is required')
        }

        if(messages.length > 0) {
          return {
            ...errors,
            [index]: messages
          }
        }

        return errors
      }, {})
      return validation || {}
    }
  },
  {
    id: 'legal',
    component: Legal,
    actionLabel: 'Legal',
    keepValuesOnPrevious: true,
    initialValues: {
      startDate: null,
      endDate: null,
      hasNda: null,
      isAssistedByPartner: null,
      billingCountryId: null,
      geographicSegmentationId: null,
      salesQueueId: null,
      signers: [],
      additionalInfo: null
    },
    validationSchema: object().shape({
      billingCountryId: number().required(),
      isAssistedByPartner: boolean().required(),
      hasNda: boolean().required(),
      startDate: date().required(),
      endDate: date().required()
    })
  }
]

export default steps
